const pad2 = (value: number) => String(value).padStart(2, '0');

export function buildProtectorConfrontationCsvFilename(cuit: string, date: Date): string {
  const safeCuit = (cuit || 'sin-cuit').replace(/[^\w-]+/g, '_');
  const stamp = `${date.getFullYear()}${pad2(date.getMonth() + 1)}${pad2(date.getDate())}-${pad2(date.getHours())}${pad2(date.getMinutes())}`;
  return `movimientos-afrontes-honras_${safeCuit}_${stamp}.csv`;
}
